import { OrderItem } from './order-item.model';

export class OrderDetails {
    id: string;
    merchantName: string;
    merchantExtSingleUseToken: string;
    totalAmount: number;
    onSuccessUri: string;
    onCancelUri: string;
    items: OrderItem[];
}